import { ReactNode } from "react";
import { ContentAuthor } from "@/graphql/gql/graphql";
import NewsletterWidgetTop from "../newsletter/NewsletterWidgetTop";
import AuthorCommon from "./AuthorCommon";
import styles from "./shareBar.module.scss";

export type ShareBarProps = {
  author: ContentAuthor;
  date: string;
  rightSlot: ReactNode;
  hideTopNewsletter: boolean | undefined | null;
};

const ShareBar = ({
  author,
  date,
  rightSlot,
  hideTopNewsletter = false,
}: ShareBarProps) => (
  <div className={styles.container}>
    <AuthorCommon author={author} date={date} />
    <div className={styles.newsletterContainer}>
      {!hideTopNewsletter ? (
        <NewsletterWidgetTop shareBtns={rightSlot} />
      ) : (
        rightSlot
      )}
    </div>
  </div>
);

export default ShareBar;
